import React, { useMemo } from 'react';
import { TutorialProvider, createApiTutorialStore } from '@nsi-advisory-services/components';
import { useAuth } from '../contexts/AuthContext';
import useAuthenticatedFetch from '../hooks/useAuthenticatedFetch';
import { apiRequest } from '../hooks/useQueries';
import timesheetTutorial from './timesheetTutorial';

const TUTORIALS = [timesheetTutorial];

// Every tutorial in the app, with each person's progress kept on the server (/api/tutorials). To
// add one, write its definition and list it above; the page runs it with useTutorialData,
// useTutorialAutoStart and a TutorialButton.
export default function TutorialHost({ children }) {
  const auth = useAuth();
  const authenticatedFetch = useAuthenticatedFetch();
  const employeeId = auth.employee?.id;
  const store = useMemo(() => createApiTutorialStore({
    userKey: employeeId || 'anonymous',
    request: (path, options) => apiRequest(authenticatedFetch, path, options),
  }), [authenticatedFetch, employeeId]);

  return <TutorialProvider tutorials={TUTORIALS} store={store}>{children}</TutorialProvider>;
}
